// extracted by mini-css-extract-plugin
module.exports = {"box":"_93444fe79c--box--HW1Bz","round-icon":"_93444fe79c--round-icon--BVZVa","box-header":"_93444fe79c--box-header--ziiZt","box-description":"_93444fe79c--box-description--QP_FP"};